// libs
import { styled } from '@nykaa/ui-components';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import {
  DWEB_PRIMARY_HEADER_HEIGHT,
  DWEB_SECONDARY_HEADER_HEIGHT,
  PROMO_BANNER_HEIGHT,
} from 'shared/styles/base';
import { fadeIn } from 'shared/styles/animations/fadeIn';

export const TitleContainer = styled.div<{ selected: boolean; }>`
  height: ${DWEB_SECONDARY_HEADER_HEIGHT}px;
  padding: ${({ theme }) => `${theme.spacing.spacing40} ${theme.spacing.spacing80}`};
  cursor: pointer;

  justify-content: center;
  align-items: center;
  display: flex;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.subTitleMedium};

  .flipped {
    font-size: 10px;
    transform: rotate(90deg);
    transition: transform 0.2s ease;
  }

  background: ${(props) => (props.selected ? hexToRgb(props.theme.colors.primary, 0.04) : '')};
`;

export const ContentContainer = styled.div`
  position: fixed;
  top: ${PROMO_BANNER_HEIGHT + DWEB_PRIMARY_HEADER_HEIGHT + DWEB_SECONDARY_HEADER_HEIGHT}px;
  left: 0;
  height: 100px;
  background-color: ${({ theme }) => theme.colors.surface};
  width: 100%;
  overflow: hidden;
  ${fadeIn};
`;

export const ChevronUpDownIcon = styled.div<{
  marginLeft: number;
  displayType: string;
  shouldShowUp: boolean;
}>`
  display: ${(props) => props.displayType};
  margin-left: ${(props) => props.marginLeft}px;
  ${(props) =>
    props.shouldShowUp &&
    `
    transform: rotate(-180deg);
    transition: transform 0.2s ease 0s;
  `}
`;

export const Button = styled.button`
  outline: 0;
  border: 0;
  background: none;
  position: relative;
  color: ${({ theme }) => theme.colors.textSecondary};
`;
